import React from 'react';
import { AwardIcon, CheckIcon, UserIcon, TargetIcon, EyeIcon, GraduationCapIcon, UsersIcon } from 'lucide-react';
import Button from '../components/ui/Button';
const About = () => {
  return <div className="w-full pt-24" data-id="element-117">
      {/* Page Header - Updated to remove "About" */}
      <section className="bg-primary py-16 relative overflow-hidden" data-id="element-118">
        <div className="absolute inset-0 opacity-10" style={{
        backgroundImage: "url('data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E')"
      }} data-id="element-119"></div>
        <div className="container mx-auto px-4 text-center relative z-10" data-id="element-120">
          <h1 className="text-white font-bold mb-4" data-id="element-121">MAGNAVERA GROUP</h1>
          <p className="text-white opacity-90 max-w-2xl mx-auto" data-id="element-122">
            Learn about our story, our values, and the people behind our
            success.
          </p>
        </div>
      </section>

      {/* Who We Are - Bold & Direct Styling */}
      <section className="py-16" data-id="element-123">
        <div className="container mx-auto px-4" data-id="element-124">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center" data-id="element-125">
            <div data-id="element-126">
              <img src="https://images.unsplash.com/photo-1507679799987-c73779587ccf?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80" alt="Magnavera Team" className="rounded-lg shadow-lg w-full" data-id="element-127" />
            </div>
            <div data-id="element-128">
              <span className="inline-block text-[#8B6914] font-bold mb-3 uppercase tracking-wider text-sm" data-id="element-129">
                Who We Are
              </span>
              <h2 className="font-bold mb-6 text-3xl" data-id="element-130">Our Story</h2>

              <p className="text-text-primary mb-6 leading-relaxed text-lg" data-id="element-131">
                Magnavera Group is a{' '}
                <span className="font-bold text-[#8B6914]" data-id="element-132">
                  Premier financial advisory practice
                </span>{' '}
                built with a bold mission: to empower individuals and families
                with the clarity, confidence, and capability to design the lives
                and legacies they truly desire.
              </p>

              <p className="text-text-secondary mb-6 leading-relaxed" data-id="element-133">
                We combine trusted guidance, lifelong financial education, and
                innovative wealth strategies to help our clients move beyond
                short-term decisions and step into long-term success. Our
                practice is built on three unshakable pillars:
              </p>

              <div className="my-8 py-6 px-8 bg-[#8B6914]/10 border-l-4 border-[#8B6914] rounded-r" data-id="element-134">
                <p className="text-[#8B6914] font-bold text-2xl tracking-wide" data-id="element-135">
                  Education. Ethics. Empowerment.
                </p>
              </div>

              <p className="text-text-secondary mb-6 leading-relaxed" data-id="element-136">
                Our team of experienced advisors brings deep expertise across
                life planning, wealth protection, and legacy design. Every
                strategy is crafted with intention—tailored, future-ready, and
                grounded in integrity.
              </p>

              <div className="my-6 py-4 px-6 bg-gray-50 border-l-4 border-[#8B6914] rounded-r" data-id="element-137">
                <p className="text-gray-900 font-bold text-lg" data-id="element-138">
                  We don't sell products. We architect solutions that endure.
                </p>
              </div>

              <p className="text-text-secondary mb-6 leading-relaxed" data-id="element-139">
                Today, Magnavera Group continues to grow while keeping our
                founding belief at the centre of everything we do:
              </p>

              <div className="my-8 py-6 px-8 bg-[#8B6914]/10 border-l-4 border-[#8B6914] rounded-r" data-id="element-140">
                <p className="text-[#8B6914] font-bold text-2xl tracking-wide" data-id="element-141">
                  Clients first. Always.
                </p>
              </div>

              <p className="text-text-secondary leading-relaxed" data-id="element-142">
                We are proud of the long-term relationships we build and the
                trust we earn across generations.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Mission & Vision - Updated Content */}
      <section className="py-16 bg-background" data-id="element-143">
        <div className="container mx-auto px-4" data-id="element-144">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12" data-id="element-145">
            {/* Mission */}
            <div className="bg-white p-8 rounded-lg shadow-lg" data-id="element-146">
              <div className="bg-[#8B6914]/10 p-4 rounded-full inline-block mb-6" data-id="element-147">
                <TargetIcon size={32} className="text-[#8B6914]" data-id="element-148" />
              </div>
              <h2 className="font-bold mb-6 text-gray-900" data-id="element-149">Our Mission</h2>
              <p className="text-gray-900 font-bold text-lg mb-4 leading-relaxed" data-id="element-150">
                To empower individuals and families through clarity, education,
                and ethical guidance—equipping at least one person in every
                household to become a confident financial decision-maker.
              </p>
              <p className="text-gray-700 leading-relaxed" data-id="element-151">
                We exist to raise financial literacy, elevate human potential,
                and help people achieve freedom, dignity, and long-term
                stability through personalised, transparent planning.
              </p>
            </div>

            {/* Vision */}
            <div className="bg-white p-8 rounded-lg shadow-lg" data-id="element-152">
              <div className="bg-[#8B6914]/10 p-4 rounded-full inline-block mb-6" data-id="element-153">
                <EyeIcon size={32} className="text-[#8B6914]" data-id="element-154" />
              </div>
              <h2 className="font-bold mb-6 text-gray-900" data-id="element-155">Our Vision</h2>
              <p className="text-gray-900 font-bold text-lg mb-4 leading-relaxed" data-id="element-156">
                To build Asia's most trusted and relationship-focused financial
                advisory group—one that transforms ambition into lasting legacy.
              </p>
              <p className="text-gray-700 leading-relaxed" data-id="element-157">
                We envision a community where empowered individuals guide their
                families towards security, growth, and intergenerational
                success, supported by advisors who lead with integrity,
                innovation, and service.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Our Purpose - Fixed contrast for better readability */}
      <section className="py-16 bg-white" data-id="element-158">
        <div className="container mx-auto px-4" data-id="element-159">
          <div className="max-w-4xl mx-auto" data-id="element-160">
            <div className="text-center mb-12" data-id="element-161">
              <span className="inline-block text-[#8B6914] font-bold mb-3 uppercase tracking-wider text-sm" data-id="element-162">
                Our Purpose
              </span>
              <h2 className="font-bold mb-6 text-3xl text-gray-900" data-id="element-163">
                Empowering One Champion in Every Family
              </h2>
              <div className="w-20 h-1 bg-[#8B6914] mx-auto" data-id="element-164"></div>
            </div>

            <div className="prose prose-lg max-w-none" data-id="element-165">
              <p className="text-gray-700 leading-relaxed mb-6 text-lg" data-id="element-166">
                Every family's financial security begins with{' '}
                <span className="font-bold text-[#8B6914]" data-id="element-167">
                  one financially empowered person—a champion
                </span>{' '}
                who understands the fundamentals, asks the right questions, and
                makes informed decisions that protect and grow wealth across
                generations.
              </p>

              <p className="text-gray-800 leading-relaxed mb-6 text-lg" data-id="element-168">
                <span className="font-bold text-[#8B6914]" data-id="element-169">
                  That is the person we help you become.
                </span>
              </p>

              <p className="text-gray-700 leading-relaxed mb-6 text-lg" data-id="element-170">
                We don't just manage portfolios or sell policies. We educate,
                equip, and empower you to take ownership of your financial
                future with clarity and confidence. Through personalised
                guidance, transparent planning, and lifelong learning, we ensure
                you have the knowledge and tools to lead your family toward
                lasting security.
              </p>

              <p className="text-gray-700 leading-relaxed mb-8 text-lg" data-id="element-171">
                When you work with Magnavera Group, you're not just a client—you
                become a financial champion. And when one person in a household
                is empowered, the entire family benefits.
              </p>

              <div className="bg-[#8B6914]/10 border-l-4 border-[#8B6914] p-6 rounded-r" data-id="element-172">
                <p className="text-[#8B6914] font-bold text-lg mb-3" data-id="element-173">
                  From uncertainty to clarity.
                </p>
                <p className="text-[#8B6914] font-bold text-lg mb-3" data-id="element-174">
                  From reactive to proactive.
                </p>
                <p className="text-[#8B6914] font-bold text-lg" data-id="element-175">
                  From dependent to empowered.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Values & Awards - Fixed contrast for better readability */}
      <section className="py-16 bg-background" data-id="element-176">
        <div className="container mx-auto px-4" data-id="element-177">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12" data-id="element-178">
            {/* Values */}
            <div data-id="element-179">
              <h2 className="font-bold mb-6 text-white" data-id="element-180">What we stand for</h2>
              <p className="mb-6 text-gray-300" data-id="element-181">
                Magnavera Group stands on principles that define how we serve,
                how we lead, and how we build lasting impact for the families
                who trust us.
              </p>
              <ul className="space-y-6" data-id="element-182">
                {[{
                title: 'Client-First, Always',
                description: 'We prioritise what is right for you — not what is profitable for us. Every recommendation is crafted with your goals, your values, and your long-term interests at the centre.'
              }, {
                title: 'Transparency That Builds Trust',
                description: 'We communicate clearly, honestly, and without jargon. You will always understand your options, risks, and opportunities before making any decision.'
              }, {
                title: 'Expertise Backed by Continuous Learning',
                description: 'Our advisors invest heavily in ongoing education, staying at the forefront of industry developments to bring you the most informed, future-ready strategies.'
              }, {
                title: 'Integrity Without Compromise',
                description: 'Trust is our currency. We uphold the highest ethical standards in every interaction, building relationships that stand the test of time.'
              }, {
                title: 'Accessible and Present When It Matters Most',
                description: 'Life happens — and we show up. We are here when you need us, especially during challenging moments, offering clarity, comfort, and actionable guidance.'
              }].map((value, index) => <li key={index} className="flex" data-id="element-183">
                    <CheckIcon className="text-[#8B6914] flex-shrink-0 mr-3 mt-1" size={20} data-id="element-184" />
                    <div data-id="element-185">
                      <p className="font-semibold text-white" data-id="element-186">{value.title}</p>
                      <p className="text-sm text-gray-300" data-id="element-187">
                        {value.description}
                      </p>
                    </div>
                  </li>)}
              </ul>
              <p className="mt-6 font-medium text-gray-200" data-id="element-188">
                These are the principles that guide how we empower one financial
                champion in every family.
              </p>
            </div>

            {/* Awards */}
            <div data-id="element-189">
              <h2 className="font-bold mb-6 text-white" data-id="element-190">
                Awards & Recognition
              </h2>
              <div className="grid grid-cols-2 sm:grid-cols-3 gap-4" data-id="element-191">
                {[1, 2, 3, 4, 5, 6].map(item => <div key={item} className="bg-white p-4 rounded-lg shadow-card text-center" data-id="element-192">
                    <AwardIcon className="text-[#8B6914] mx-auto mb-2" size={32} data-id="element-193" />
                    <p className="font-semibold text-sm text-gray-900" data-id="element-194">
                      MDRT Qualifications {2015 + item}
                    </p>
                  </div>)}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Join Us CTA - Updated content */}
      <section className="py-16 bg-primary text-white" data-id="element-195">
        <div className="container mx-auto px-4 text-center" data-id="element-196">
          <h2 className="font-bold mb-6 text-2xl md:text-3xl" data-id="element-197">
            Build a Career That Transforms Lives — Starting With Your Own
          </h2>
          <div className="max-w-3xl mx-auto" data-id="element-198">
            <p className="mb-4 opacity-95 text-lg" data-id="element-199">
              Join Magnavera Group and become the financial champion every
              family needs.
            </p>
            <p className="mb-4 opacity-95" data-id="element-200">
              We invest in your education, train you for excellence, and empower
              you to build a career filled with impact, purpose, and unlimited
              potential.
            </p>
            <p className="mb-8 opacity-95 italic" data-id="element-201">
              If you want growth, mentorship, community, and a place where your
              ambition is celebrated — you're home.
            </p>
          </div>
          <Button href="/careers" variant="secondary" className="bg-white text-primary" data-id="element-202">
            Explore Career Opportunities
          </Button>
        </div>
      </section>
    </div>;
};
export default About;